import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Facility } from '../../interfaces/facilty';
import { navigateToFacility } from '../../utils/navigate-utils';
import { Router } from '@angular/router';
import { TableComponent } from '../../../../../shared/src/lib/components/table/table.component';
import { TableHeaderComponent } from '../../../../../shared/src/lib/components/table-header/table-header.component';

import { TableRowComponent } from '../../../../../shared/src/lib/components/table-row/table-row.component';
import { TableCellComponent } from '../../../../../shared/src/lib/components/table-cell/table-cell.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-facility-list',
    templateUrl: './facility-list.component.html',
    styleUrls: ['./facility-list.component.scss'],
    imports: [TableComponent, TableHeaderComponent, TableRowComponent, TableCellComponent, TranslateModule]
})
export class FacilityListComponent {
  @Input()
  facilities: Facility[];

  constructor(private router: Router) {}

  public navigateToFacility(facility: Facility) {
    navigateToFacility(this.router, facility);
  }


}
